import { DeepPartial, AppConfig, Menu } from "../../../../src/app/interfaces/app-config";

export const projectConfig: DeepPartial<AppConfig> = {
  mobileMenu: [
    Menu.create({
      id: 1,
      path: '/home',
      title: 'Comprar',
      icon: '/assets/icons/home_white.svg',
      iconType: 'img'
    }),
    Menu.create({
      id: 3,
      path: '/tickets-saved',
      title: 'Mis Compras',
      icon: '/assets/icons/ticket_white.svg',
      iconType: 'img'
    }),
    Menu.create({
      id: 3,
      path: '/search',
      title: 'Buscar',
      icon: '/assets/icons/search_white.svg',
      iconType: 'img'
    }),
  ],
  footerMenu: [
    {
      id: 1,
      title: 'Páginas',
      menu: [
        Menu.create({
          id: 2,
          path: '/privacy-policy',
          title: 'Política de privacidad y cookies',
          external: false,
        }),
      ]
    },
    {
      id: 2,
      title: 'Contacto',
      menu: [
        Menu.create({
          id: 8,
          path: 'mailto:soporte@todotix.com',
          title: 'soporte@todotix.com',
          external: true,
          target: '_blank',
          icon: '/assets/icons/mail.svg',
          iconType: 'img'
        }),
        Menu.create({
          id: 8,
          path: 'https://www.facebook.com/todotix',
          title: 'Todotix',
          external: true,
          target: '_blank',
          icon: '/assets/icons/facebook.svg',
          iconType: 'img'
        }),
        Menu.create({
          id: 9,
          path: 'https://www.instagram.com/todotix',
          title: 'Todotix',
          external: true,
          target: '_blank',
          icon: '/assets/icons/instagram.svg',
          iconType: 'img'
        }),
        Menu.create({
          id: 10,
          path: 'https://www.tiktok.com/@todotix',
          title: 'Todotix',
          external: true,
          target: '_blank',
          icon: '/assets/icons/tiktok-border.svg',
          iconType: 'mask'
        }),
        Menu.create({
          id: 11,
          path: 'https://api.whatsapp.com/send/?phone=59169777799&text=Tengo+una+consulta+respecto+a+Todotix&type=phone_number&app_absent=0',
          title: 'Todotix',
          external: true,
          target: '_blank',
          icon: '/assets/icons/whatsapp.svg',
          iconType: 'img'
        }),
      ]
    }
  ],
  pages: {
    login: {
      title: 'Login',
    }
  },
  menu: [
    Menu.create({
      id: 2,
      path: '/home',
      title: 'Comprar',
    }),
    Menu.create({
      id: 3,
      path: '/tickets-saved',
      title: 'Mis Tickets',
    }),
    Menu.create({
      id: 3,
      path: '/farmacorp-branchs',
      title: 'Sucursales Farmacorp',
    }),
  ],

  authGoogle: true,
  zendeskKey: '0d2db56d-572c-4fe5-ba09-198d0fbf462d',
  facebookPixelKey: '1394425368241619',
  appleWallet: true,
  googleWallet: true,
  bgDarkRoutes: ['home', 'characteristics', 'redirect'],
  bgCustomRoutes: ['tickets-saved', 'search'],
};


import { Injector } from "@angular/core";
import { EncryptionService } from "../../../../src/app/services/encryption.service";
import { environment } from "../environments/environment";

const injector = Injector.create({providers: [{provide: EncryptionService, useClass: EncryptionService, deps: []}]});
const encryptionService = injector.get(EncryptionService);

export function projectEncryptData(data: any) {
  const encryptedConfig = encryptionService.encrypt(data, environment.keyEncript, environment.ivEncript);
  return encryptedConfig;
}